module.exports = __webpack_public_path__ + "img/9788954426541.9506f940.jpg";